// Data de abertura oficial: 1 de Julho de 2026, hora de Lisboa.
// Antes desta data, o site mostra elementos de "pré-abertura"
// (contagem decrescente, barra de topo, marca "Em Preparação" e
// nota provisória na galeria). A partir desta data, esses elementos
// desaparecem sozinhos no próximo carregamento da página.
export const OPENING_DATE = new Date("2026-07-01T00:00:00+01:00");

export function isPreOpening() {
  return new Date() < OPENING_DATE;
}
